import { getTermValue, resetTerms, TJsonQueryOptionalKeys, TJsonQueryTermKeys } from '../../../JsonQuery';
import { TTagsManager } from '../types/tag';
import { createTagValue } from './createTagValue';
import { fillLabelTemplate } from './fillLabelTemplate';

interface IParams {
  jsonQueryKey: TJsonQueryTermKeys;
  label?: string;
  template?: string;
  id: string;
}

export const createTermTagManager = ({ jsonQueryKey, label = '', template, id }: IParams): TTagsManager => ({
  id,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const termValue = getTermValue(jsonQueryKey)(jsonQuery);

    if (termValue === null) {
      return null;
    }

    const tagLabel = template ? fillLabelTemplate(template, termValue.toString()) : label;

    return [{ label: tagLabel, value: createTagValue(id) }];
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery }) => resetTerms([jsonQueryKey as TJsonQueryOptionalKeys])(jsonQuery),
});
